function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_awesome-coins",
  "data-name": "Icon awesome-coins",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-coins-2",
  "data-name": "Icon awesome-coins",
  d: "M0,45.913V50.75c0,4,9.742,7.25,21.75,7.25S43.5,54.749,43.5,50.75V45.913c-4.679,3.3-13.231,4.837-21.75,4.837S4.679,49.209,0,45.913ZM36.25,14.5C48.258,14.5,58,11.249,58,7.25S48.258,0,36.25,0,14.5,3.251,14.5,7.25,24.242,14.5,36.25,14.5ZM0,34.03v5.845c0,4,9.742,7.25,21.75,7.25s21.75-3.251,21.75-7.25V34.03c-4.679,3.852-13.243,5.845-21.75,5.845S4.679,37.881,0,34.03Zm47.125,1.246C53.616,34.018,58,31.685,58,29V24.163c-2.628,1.858-6.491,3.127-10.875,3.908ZM21.75,18.125C9.742,18.125,0,22.18,0,27.188S9.742,36.25,21.75,36.25,43.5,32.195,43.5,27.188,33.758,18.125,21.75,18.125ZM46.593,24.5C53.389,23.279,58,20.878,58,18.125V13.288c-4.021,2.843-10.932,4.373-18.2,4.735C43.138,19.643,45.6,21.818,46.593,24.5Z",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgHassleFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHassleFree);
export default __webpack_public_path__ + "static/media/hassleFree.82d0043b632040d4acc2c32f55c28412.svg";
export { ForwardRef as ReactComponent };